import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import type ArchivedDirectLinkType from '@atlassian/jira-project-archived-direct-link/src/ui/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { archivedProjectDirectLinkRoute } from '@atlassian/jira-router-routes-archived-project-direct-link-routes/src/archivedProjectDirectLinkRoute.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyArchivedDirectLink = lazyForPaint<typeof ArchivedDirectLinkType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-archived-direct-link", jiraSpaEntry: "async-project-archived-direct-link" */ '@atlassian/jira-project-archived-direct-link'
		),
	),
);

const ArchivedProjectDirectLink = () => (
	<LazyPage
		Page={LazyArchivedDirectLink}
		pageId="archived-project-direct-link"
		shouldShowSpinner={false}
	/>
);

export const archivedProjectDirectLinkRouteEntry: Route = createEntry(
	archivedProjectDirectLinkRoute,
	() => ({
		group: 'redirects',
		component: ArchivedProjectDirectLink,
		layout: globalLayout,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyArchivedDirectLink],
		ufoName: 'project-archived',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-archived-project-direct-link-entries/src/archivedProjectDirectLinkRouteEntry.tsx',
				whichExportToUse: 'archivedProjectDirectLinkRouteEntry',
			},

			enabled: true,
		},
	}),
);
